import React from 'react'
import { Header } from 'semantic-ui-react'
import { AccountSearchBar } from '../../components/AccountSearch'
import { PermissionDenied } from '../../components/PermissionDenied'
import { usePermissions } from '../../hooks'
import layoutStyles from '../AppLayout/styles.module.less'
import { PermissionsEnum } from '../contexts/permissions/constants'
import TradeSubmissionSuccessToaster from '../TradeForm/TradeSubmissionSuccessToaster'

const HomePage: React.FunctionComponent = () => {
  const { hasPermission } = usePermissions()
  if (hasPermission(PermissionsEnum.TradeReportsModify)) {
    return (
      <>
        <div className={layoutStyles.offsetBar}>
          <AccountSearchBar />
          <TradeSubmissionSuccessToaster />
        </div>
        <Header as="h1" textAlign="center" className={layoutStyles.homeHeader}>
          Apex Trade Entry
        </Header>
        <p className={`h2 ${layoutStyles.homeSubheader}`}>
          Please enter an account number, name, or SSN in the form above to start a Trade Entry.
        </p>
      </>
    )
  }
  return (
    <>
      <PermissionDenied />
      <Header as="h1" textAlign="center" className={layoutStyles.homeHeader}>
        Apex Trade Entry
      </Header>
    </>
  )
}

export default HomePage
